
import HeaderMixin from './header-mixin'
import dimensions from '~/assets/vars/dimensions'
import { isDark } from '@bkwld/light-or-dark'
export default

	mixins: [ HeaderMixin ]

	data: ->
		height: parseInt dimensions['mobile-header-h']
		scrollPosition: null

	computed:
		availableSites: -> @$store.state.localization?.availableSites
		showLanguageSelector: -> @availableSites?.length > 1

		maskStyle: -> if @scrollPosition then "transform: translateY(#{-@scrollPosition}px)"

	methods:
		scroll: (scrollValue) ->
			@scrollPosition = scrollValue

